export default __webpack_public_path__ + "static/seven-1ad228b7fbcf82567d604ad556295426.jpg";